export type OpenCard = {
  id: string;
  name: string;
  tasted_on: string | null;
  arrival_time: string | null;
  venue_choice: string | null;
  venue: string;
  step: number;
  created_at: string;
  href: string;
};

const VENUE_FILTERS = ["casa", "ktema", "regina", "other"] as const;
export type VenueFilter = (typeof VENUE_FILTERS)[number];

export function venueFilterOf(value: string | null | undefined): VenueFilter | null {
  return (VENUE_FILTERS as readonly string[]).includes(value ?? "") ? value as VenueFilter : null;
}

export function venueBadge(choice: string | null | undefined, other: string | null | undefined): string {
  if (choice === "casa") return "CASA";
  if (choice === "ktema") return "ΚΤΗΜΑ";
  if (choice === "regina") return "REGINA";
  if (choice === "other") return (other ?? "").trim() || "ΑΛΛΟ";
  return "Χωρίς χώρο";
}

/** Upcoming dates first, then cards with no date (newest first), then past dates. */
export function compareOpenCards(left: OpenCard, right: OpenCard, today: string): number {
  const group = (card: OpenCard) => (!card.tasted_on ? 1 : card.tasted_on >= today ? 0 : 2);
  const leftGroup = group(left);
  const rightGroup = group(right);
  if (leftGroup !== rightGroup) return leftGroup - rightGroup;
  if (leftGroup === 0 && left.tasted_on !== right.tasted_on) return (left.tasted_on ?? "").localeCompare(right.tasted_on ?? "");
  if (leftGroup === 0) {
    const leftTime = left.arrival_time ?? "99:99";
    const rightTime = right.arrival_time ?? "99:99";
    if (leftTime !== rightTime) return leftTime.localeCompare(rightTime);
  }
  if (leftGroup === 2 && left.tasted_on !== right.tasted_on) return (right.tasted_on ?? "").localeCompare(left.tasted_on ?? "");
  if (left.created_at !== right.created_at) return right.created_at.localeCompare(left.created_at);
  return left.name.localeCompare(right.name, "el") || left.id.localeCompare(right.id);
}

export function filterOpenCards(cards: OpenCard[], query: string, venue: VenueFilter | null): OpenCard[] {
  const needle = query.trim().toLocaleLowerCase("el");
  return cards.filter((card) => {
    if (venue && card.venue_choice !== venue) return false;
    if (!needle) return true;
    return [card.name, card.venue, card.tasted_on, card.arrival_time].join(" ").toLocaleLowerCase("el").includes(needle);
  });
}

export function tastingWhen(date: string | null, time: string | null): string {
  const day = date && /^\d{4}-\d{2}-\d{2}$/.test(date) ? `${date.slice(8, 10)}/${date.slice(5, 7)}/${date.slice(0, 4)}` : "Χωρίς ημερομηνία";
  return time ? `${day} · Ώρα άφιξης ${time}` : day;
}
